import {getEndpointByHotelCode} from "../utilities/property/getClientIdByHotelCode";

export const MODIFY_POST_ENHANCEMENTS_BEGIN = 'MODIFY_POST_ENHANCEMENTS_BEGIN'
export const MODIFY_POST_ENHANCEMENTS_SUCCESS = 'MODIFY_POST_ENHANCEMENTS_SUCCESS'
export const MODIFY_POST_ENHANCEMENTS_ERROR = 'MODIFY_POST_ENHANCEMENTS_ERROR'

export const modifyPostEnhancementsBegin = ({
	type: MODIFY_POST_ENHANCEMENTS_BEGIN
})

export const modifyPostEnhancementsSuccess = confirmation => ({
	type: MODIFY_POST_ENHANCEMENTS_SUCCESS,
	payload: confirmation
})

export const modifyPostEnhancementsError = error => ({
	type: MODIFY_POST_ENHANCEMENTS_ERROR,
	payload: { error }
})

export default function modifyPostEnhancements(urlData, activeRoom, activeEnhancementData, activeGuest, activePayment, activeCreditType, reservationData) {
	return dispatch => {
		let currentEndpointUrl = getEndpointByHotelCode(urlData.hotelCode);

		// Mapping card type to Synxis values
		let formattedCardType = ''
		switch (activeCreditType) {
			case 'visa':
				formattedCardType = 'VI'
				break
			case 'mastercard':
				formattedCardType = 'MC'
				break
			case 'maestro':
				formattedCardType = 'SW'
				break
			case 'amex':
				formattedCardType = 'AX'
				break
			case 'diners':
				formattedCardType = 'DN'
				break
			case 'discover':
				formattedCardType = 'DS'
				break
			case 'jcb':
				formattedCardType = 'JC'
				break
			default:
				formattedCardType = 'undefined'
				break
		}

		let reservationEntries = {
			modifyParameters: []
		}

		// Window.session data for guests / pets
		const flowGuestData = JSON.parse(localStorage.flowGuestData)

		// Construct reservation data
		for (let roomKey in activeRoom) {

			// Construct enhancements
			let servicesEnhancements = []

			for (let enhancementKeys in activeEnhancementData) {
				if (activeEnhancementData[enhancementKeys].roomGroup === roomKey && activeEnhancementData[enhancementKeys].roomType === activeRoom[roomKey][0][0].roomTypeCode) {
					// Format individual services
					let serviceEnhancement = {
							serviceInventoryCode: activeEnhancementData[enhancementKeys].enhancementApiData.serviceInventoryCode,
							dateStart: urlData.startDate,
							adults: flowGuestData[roomKey].adults,
							children: flowGuestData[roomKey].children
						}

					// Combine formatted services for reservationEntry
					servicesEnhancements.push(serviceEnhancement)
				}
			}

			let reservationEntry = {
				roomStays: {
					crsConfirmNumber: reservationData.confirmation.hotelReservations[roomKey].uniqueId.id,
					hotelCode: urlData.hotelCode,
					chainCode: "9139",
					dateStart: urlData.startDate,
					dateEnd: urlData.endDate,
					ratePlanCode: activeRoom[roomKey][1][0].ratePlanCode,
					adults: flowGuestData[roomKey].adults,
					children: flowGuestData[roomKey].children,
					roomTypes: {
						roomTypeCode: activeRoom[roomKey][0][0].roomTypeCode,
						numberOfUnits: 1
					}
				},
				resGuests: {
					givenName: activeGuest.values.firstName,
					surName: activeGuest.values.lastName,
					telephone: activeGuest.values.phone,
					email: activeGuest.values.email,
					primary: true,
				},
				comments: [],
				paymentCard: {
					cardNumber: activePayment.values.creditCard.replace(/\s/g, ''),
					cardCode: formattedCardType,
					seriesCode: activePayment.values.cvv,
					expireDate: activePayment.values.expirationMonth + '/' + activePayment.values.expirationYear,
					cardHolderName: activeGuest.values.firstName + ' ' + activeGuest.values.lastName
				},
				services: servicesEnhancements,
				iataId: ""
			}

			// Append activeRooms to reservationEntries
			reservationEntries['modifyParameters'].push(reservationEntry)
		}
		// Begin create reservation set loading true & error false
		dispatch(modifyPostEnhancementsBegin)

		// Base API path
		let apiBase = currentEndpointUrl

		// Initial reservation request
		fetch(apiBase + reservationData.confirmation['@id'], {
			method: 'PUT',
			headers: {
				Accept: 'application/ld+json',
				'Content-Type': 'application/ld+json',
			},
			body: JSON.stringify(reservationEntries)
		})
			.then(handleReservationErrors)
			.then(response => response.json())
			.then((data) => {
				dispatch(modifyPostEnhancementsSuccess(data))
			})
			.catch(error => dispatch(modifyPostEnhancementsError(error)))

		// Handle HTTP errors for Reservations
		function handleReservationErrors(response) {
			if (!response.ok) throw Error(response.statusText)
			return response
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/modifyPostEnhancementsActions.js